import { SET_AVAILABLE_TIMES, CLEAR_AVAILABLE_TIMES } from './actionTypes';
import { RESET_APP_STATE } from 'store/actionTypes';
import initialState from 'store/initialState';

export default function(
  state = initialState.availableTimes,
  { type, payload }
) {
  switch (type) {
    case SET_AVAILABLE_TIMES:
      return payload;
    case CLEAR_AVAILABLE_TIMES:
    case RESET_APP_STATE:
      return initialState.availableTimes;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/availableTimes/reducer.js